/**
 * Decode the `?org=` URL param defensively. `decodeURIComponent` throws a
 * `URIError` on a malformed percent-escape (e.g. `?org=%E0%A4%A`), which would
 * otherwise crash route resolution / org hydration on a crafted URL. Returns
 * the lowercased decoded value, or `null` when the param is absent or malformed.
 */
export function safeDecodeOrgParam(orgParam: string | undefined): string | null {
  if (!orgParam) return null;
  try {
    return decodeURIComponent(orgParam).toLowerCase();
  } catch {
    return null;
  }
}
